import { Component } from 'react';
import { Col, Modal, Row } from 'react-bootstrap';
import moment from 'moment';
import { inject, observer } from 'mobx-react';

//components
import { longDateFormat } from '../../../utils/dateFormat';
import applicationRouter from '../../../hoc/applicationRouter';
import DatePicker from '../../../components/DatePicker/DatePicker';
import withLocalization from '../../../hoc/withLocalization';
import { MembersWidget } from '../../../components/GenericForm/Widgets/UsersWidget';
import { TasksWidget } from '../../../components/GenericForm/Widgets/TasksWidget';
import TimePickerInput from '../../../components/TimePicker';
import Button from '../../../components/CustomButton/CustomButton.jsx'
import InputTime from '../../../components/GenericForm/Widgets/InputTime.js';
import { getCompanyShiftDetails } from '../../../utils/commonMethods.js';
import { ProjectsWidget } from '../../../components/GenericForm/Widgets/ProjectsWidget.js';

//utils
import { getMinutesFromTimeInput, minutesToTimeInput } from '../../../utils/timeCalc.js';

//assets
import CloseModalIcon from '../../../assets/img/CloseApproveModalIcon.svg';
import startIcon from '../../../assets/img/startIcon.svg';
import endIcon from '../../../assets/img/endIcon.svg';

class PastTimeLogModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            timelogData: {
                for_date: new Date(moment().subtract(1, 'days').toDate()),
                from: '08:00',
                to: '16:00',
                user_id: null,
                task_id: null,
                data: {
                    workplace: ''
                },
                client_id: null,
                description: null,
                status: 'active',
                tracker_status: 'manual',
                project_id: null,
                gps_data: null,
                total_hours_normal: '08:00',
                total_hours_overtime: '00:00',
                break: 0,
                total_hours_overall: '08:00',
                company_shift_id: null,
            }
        }
    }
    handleChange = (key, value) => {
        const { userStore } = this.props;
        const { user_type, id, company_shift_id } = userStore.currentUser;
        if (key === 'workplace') {
            this.setState(prevState => ({
                timelogData: {
                    ...prevState.timelogData,
                    data: {
                        ...prevState.timelogData.data,
                        workplace: value
                    }
                }
            }));
        } else {
            this.setState(prevState => ({
                timelogData: {
                    ...prevState.timelogData,
                    [key]: value
                }
            }), () => {
                if (key === 'from' || key === 'to' || key === 'break') {
                    this.calcTotalTime();
                }
                if (key === 'user_id' && user_type === 'pm') {
                    const company_shift_id_value = value === id ? company_shift_id : null;
                    this.handleUserShiftFind(company_shift_id_value);
                }
            });
        }
    };

    handleUserShiftFind = async (company_shift_id) => {
        const { commonStore, userStore } = this.props;
        const { auto_break } = userStore.currentUser;
        const currentShift = getCompanyShiftDetails(commonStore.config, company_shift_id, minutesToTimeInput);
        this.setState(prevState => ({
            timelogData: {
                ...prevState.timelogData,
                from: currentShift.start,
                to: currentShift.end,
                break: !auto_break ? 0 : currentShift.break,
                total_hours_overall: currentShift.total,
                company_shift_id: currentShift?.companyShiftId || null
            }
        }), () => {
            this.calcTotalTime();
        });
    }

    calcTotalTime() {
        const { timelogData } = this.state;
        const entity = Object.assign({}, timelogData);
        const fromMinutes = getMinutesFromTimeInput(entity.from);
        const endMinutes = getMinutesFromTimeInput(entity.to);
        const breakMinutes = entity.break || 0;
        entity.breakMinutes = breakMinutes;
        let totalMinutes = endMinutes - fromMinutes;
        if (endMinutes < fromMinutes) {
            totalMinutes += 24 * 60;
        }
        if (totalMinutes > breakMinutes) {
            totalMinutes -= breakMinutes;
        } else {
        }
        const totalResultPure = minutesToTimeInput(totalMinutes, 'full');
        entity.total_hours_overall = totalResultPure.positive ? totalResultPure.value : '00:00';
        totalMinutes -= getMinutesFromTimeInput(entity.total_hours_overtime);
        const totalResult = minutesToTimeInput(totalMinutes, 'full');
        entity.total_hours_normal = totalResult.positive ? totalResult.value : '00:00';
        this.setState({ timelogData: entity });
    }

    componentDidMount() {
        const { userStore } = this.props;
        const { id, client_id, company_shift_id } = userStore.currentUser;
        this.handleUserShiftFind(company_shift_id);
        this.setState(prevState => ({
            timelogData: {
                ...prevState.timelogData,
                user_id: id,
                client_id: client_id,
            }
        }));
    }


    handleSave = async () => {
        const { timelogData } = this.state
        const { timelogStore, commonStore, t } = this.props
        const transformedData = {
            ...timelogData,
            from: getMinutesFromTimeInput(timelogData.from),
            to: getMinutesFromTimeInput(timelogData.to),
            break: parseInt(timelogData.break),
            user_id: parseInt(timelogData.user_id),
            task_id: parseInt(timelogData.task_id),
            breakMinutes: parseInt(timelogData.breakMinutes),
            fromPastTimelogModal: true
        }
        if (!timelogData.task_id) {
            commonStore.addNotification(t('Please select tasks to assign'), null, 'error');
            return;
        }
        if (getMinutesFromTimeInput(timelogData.total_hours_overall) < 10) {
            commonStore.addNotification(t('Timesheet cannot be less than 10 minutes'), null, 'error');
            return;
        }
        const { timelog } = await timelogStore.saveAndOverrideCurrentEntity(transformedData, true, false);
        if (timelog && timelog.id) {
            this.props.router.navigate(`/admin/timelogs/${timelog.id}`, { state: { timelogs: timelog.id, page: 0 } })
        }
    }

    handleTaskChange = async (value, full) => {
        this.handleChange('task_id', value);
        if (!value || !parseInt(value)) return;
        const { task } = await this.props.taskStore.load(value);
        const gpsData = {};
        this.handleChange('workplace', task.address);
        if (task.gps_data) {
            gpsData.task = task.gps_data;
            this.handleChange('gps_data', gpsData);
        }
        if (task.description) {
            this.handleChange('description', task.description);
        } else {
            this.handleChange('description', full.label);
        }
    }

    handleProjectChange = (value) => {
        this.handleChange('project_id', value);
    }

    render() {
        const { commonStore, onClose, show, t, userStore } = this.props;
        const { data: clientData } = commonStore.config.client;
        const { user_type } = userStore.currentUser;
        const dateTimeRules = clientData && clientData.dateTimeRules ? clientData.dateTimeRules : false;
        const format = dateTimeRules && dateTimeRules.time_format ? dateTimeRules.time_format : 'hh:mm';
        const {
            for_date,
            from,
            to,
            data,
            user_id,
            task_id,
            total_hours_overall,
            project_id
        } = this.state.timelogData
        return (
            <Modal show={show} onHide={onClose} size="lg" >
                <Modal.Header>
                    <Modal.Title className="w-100 text-center m-0">{t('Past Timesheet')}</Modal.Title>
                    <img
                        src={CloseModalIcon}
                        className="cursor-pointer"
                        onClick={() => onClose()}
                        alt={'cross-Icon'}
                    />
                </Modal.Header>
                <Modal.Body style={{ minHeight: '80vh' }}>
                    <div className="row mb-2">
                        <div className='col-md-6 col-sm-12'>
                            <h3 className="primary-page__title">
                                {t('Register working hours')}
                            </h3>
                        </div>
                    </div>
                    <div className="row mt-4">
                        <div className='col-md-6 col-sm-12'>
                            <div className='form-group field field-string'>
                                <label className="control-label">{t('Select Date')} *</label>
                                <div className='customize-datepicker'>
                                    <DatePicker
                                        selected={for_date}
                                        onChange={(date) => this.handleChange('for_date', date)}
                                        value={for_date}
                                        dateFormat={longDateFormat(dateTimeRules)}
                                        maxDate={new Date(moment().subtract(1, 'days').format('MM/DD/YYYY'))}
                                        bgGrey={true}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-sm-12">
                            <div className="form-group field field-string">
                                <label className="control-label">{t('Select Member')} *</label>
                                <MembersWidget
                                    className="form-control"
                                    onChange={(value) => this.handleChange('user_id', value)}
                                    value={user_id}
                                    defaultIfOne
                                    style={{ borderRadius: 10 }}
                                    disabled={user_type === 'member' ? true : false}
                                />
                            </div>
                        </div>
                    </div>
                    <div className='row mt-4'>
                        <div className='col-md-6'>
                            <div className='form-group field field-string mb-3'>
                                <label className='control-label'>{t('Select Project')} *</label>
                                <ProjectsWidget
                                    className="form-control"
                                    onChange={(value, full) => this.handleProjectChange(value, full)}
                                    value={project_id}
                                    defaultIfOne
                                    filterByUser={user_id}
                                />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group field field-string mb-3">
                                <label className="control-label">{t('Select Task')} *</label>
                                <TasksWidget
                                    className="form-control"
                                    onChange={(value, full) => this.handleTaskChange(value, full)}
                                    value={task_id}
                                    defaultIfOne
                                    filterByProject={project_id}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row mt-2">
                        <div className='col-md-12'>
                            <div className="form-group field field-string mb-4 border-radius-10">
                                <label className="control-label">{t('Workplace')}</label>
                                <input
                                    className="form-control border-radius-10"
                                    type="text"
                                    value={data.workplace ? (data.workplace === 'null' ? '' : data.workplace) : ''}
                                    placeholder={t('Workplace address')}
                                    onChange={(e) => this.handleChange('workplace', e.target.value)}
                                />
                            </div>
                        </div>
                    </div>
                    <div className='mt-4'>
                        <div className='row timelog-grid-time-card'>
                            <Col xs={12} md={6} className='timelog-grid-item-1 justify-content-space-between card-timelog-grid-item'>
                                <div className="d-flex align-items-center">
                                    <i className="timelog-grid__icon">
                                        <img src={startIcon} alt="Start" />
                                    </i>
                                    <span className="timelog-grid__text">{t('Start')}</span>
                                </div>
                                <div className="d-flex align-items-center">
                                    <TimePickerInput
                                        style={{ width: 150 }}
                                        value={from}
                                        format={format === "hh:mm" ? "HH:mm" : format}
                                        onChange={value => this.handleChange('from', value)}
                                        className="worklog-input border-radius-10"
                                    />
                                </div>
                            </Col>
                            <Col xs={12} md={6} className='timelog-grid-item-2 justify-content-space-between card-timelog-grid-item'>
                                <div className='d-flex align-items-center'>
                                    <i className="timelog-grid__icon">
                                        <img src={endIcon} alt="Stop" />
                                    </i>
                                    <span className="timelog-grid__text">{t('End')}</span>
                                </div>
                                <div className='d-flex align-items-center'>
                                    <TimePickerInput
                                        style={{ width: 150 }}
                                        value={to}
                                        format={format === "hh:mm" ? "HH:mm" : format}
                                        onChange={value => this.handleChange('to', value)}
                                        className="worklog-input border-radius-10"
                                    />
                                </div>
                            </Col>
                        </div>
                    </div>
                    <div className='row timelog-grid-time-card'>
                        <Col xs={12} md={6} className='timelog-grid-item-1 justify-content-space-between align-items-center card-timelog-grid-item'>
                            <div>
                                <span className="timelog-grid__text ml-30">
                                    {t('Breaktime')}
                                </span>
                            </div>
                            <div>
                                <InputTime
                                    value={minutesToTimeInput(this.state.timelogData.break, false)}
                                    onChange={(e) =>
                                        this.handleChange('break', getMinutesFromTimeInput(e))
                                    }
                                    className={`big-input text-center`}
                                />
                            </div>
                        </Col>
                        <Col xs={12} md={6} className='timelog-grid-item-2 justify-content-space-between card-timelog-grid-item'>
                            <div className='d-flex align-items-center'>
                                <span className="timelog-grid__text ml-30">{t('Total')}</span>
                            </div>
                            <InputTime disabled value={total_hours_overall} className="big-input text-center" />
                        </Col>
                    </div>
                    <Row className="justify-content-end">
                        <Col xs="auto" className="mt-2">
                            <Button fill onClick={onClose}>
                                {t('Cancel')}
                            </Button>
                        </Col>
                        <Col xs="auto" className="mt-2">
                            <Button fill onClick={() => this.handleSave()}>
                                {t('Save and Next')}
                            </Button>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
        );
    }
}

export default inject('commonStore', 'userStore', 'timelogStore', 'taskStore')(applicationRouter(withLocalization(observer(PastTimeLogModal))));
